module.exports = __webpack_public_path__ + "img/consulta-publica.72c98d87.jpeg";